import React from 'react';
import { Breadcrumb, Typography, Space } from 'antd';
import { HomeOutlined, TeamOutlined } from '@ant-design/icons';
import ChannelPartnerList from '../components/ChannelPartners/ChannelPartnerList';

const { Title } = Typography;

const ChannelPartnersPage = () => {
    return (
        <div>
            <Breadcrumb
                style={{ marginBottom: '16px' }}
                items={[
                    {
                        href: '/',
                        title: <HomeOutlined />,
                    },
                    {
                        title: (
                            <Space>
                                <TeamOutlined />
                                <span>Channel Partners</span>
                            </Space>
                        ),
                    },
                ]}
            />

            <div style={{ marginBottom: '24px' }}>
                <Title level={2}>Channel Partners</Title>
            </div>

            <ChannelPartnerList />
        </div>
    );
};

export default ChannelPartnersPage;
